import React, { Component, Suspense, lazy } from 'react'
import store from '../../../store'
import SuspenseLoader from './../../../components/suspense_loader/SuspenseLoader'
import Sidebar from './../../../components/sidebar/Sidebar'

import './BaseballTournament.scss'
import HeaderTitle from '../../shared/HeaderTitle'

const WBCTournament = lazy(() => import('./wbc/WBCTournament'))

class BaseballTournament extends Component {
    componentDidMount() {
        store.dispatch({
            type: 'ANALYTIC_EVENT_PAGE',
            naming: {
                sport: this.props.sport,
                league: this.props.league,
                page: 'tournament',
                url: window.location.href || document.URL,
            },
        })
    }

    render() {
        const { league, sport } = this.props
        const { year } = this.props.match.params

        let seasonYear = year ? year : new Date().getFullYear()

        return (
            <div className="BaseballTournament__cont">
                <div className="inner_cont">
                    <div className="left_col">
                        <HeaderTitle title={'World Baseball Classic'} />
                        <Suspense fallback={<SuspenseLoader />}>
                            <WBCTournament {...this.props} />
                        </Suspense>
                    </div>

                    <div className="right_col">
                        <Sidebar league={league} sport={sport} year={seasonYear} />
                    </div>
                </div>
            </div>
        )
    }
}

export default BaseballTournament
